<template>
  <div class="input-error-wrap" :class="class">
    <slot/>
    <p v-if="hasError" class="error-msg"> {{ errorMessage }} </p>
  </div>
</template>
<script>
export default {
  props: {
    class: {
      type: String,
    },
    hasError: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
    }
  },
  components: {},
  data() {
    return {
    };
  },
  async mounted() {
  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
$Gray-5: #F7F8F8;
$Gray-10: #F1F2F3;
$Gray-20: #E8EBED;
$Gray-30: #DDE0E4;
$Gray-40: #C7CCD1;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$Blue : #278AEC;
$SkyBlue : #E1F0FF;
$Red: #E73023;
  .input-error-wrap {
    width: 100%;
    input[type="text"],
    input[type="password"],
    select,
    textarea {
      width: 100%;
    }
  }

  .error-msg {
    font-size: 13px;
    color: $Red;
    margin-bottom: 0px;
  }
</style>

